'use strict';

/**
 * Used as values for the "signiant-product" tag in Cloud Formation stacks.
 */
module.exports = {
    FLIGHT: 'Flight',
    JET: 'Jet',
    MANAGER_AND_AGENTS: 'MandA',
    MEDIA_SHUTTLE: 'Media Shuttle',
    PLATFORM: 'Platform'
};